import {
    jsonToXml, jsonToYaml, jsonToCsv,
    csvToJson, csvToXml, csvToYaml, csvToHtml, csvToMarkdown,
    yamlToJson, yamlToXml, yamlToCsv,
    xmlToJson, xmlToYaml, xmlToCsv,
} from '../../../utils/converters';
import {
    jsonSample as jsonPlaceholder,
    csvSample as csvPlaceholder,
    yamlSample as yamlPlaceholder,
    xmlSample as xmlPlaceholder,
} from '../../../utils/sampleData';

export const converterSources = [
    {
        key: 'json',
        label: 'JSON',
        placeholder: jsonPlaceholder,
        targets: [
            {key: 'xml', label: 'XML', convert: jsonToXml, extension: 'xml', mimeType: 'application/xml', formattable: true},
            {key: 'yaml', label: 'YAML', convert: jsonToYaml, extension: 'yaml', mimeType: 'application/x-yaml'},
            {key: 'csv', label: 'CSV', convert: jsonToCsv, extension: 'csv', mimeType: 'text/csv'},
        ],
    },
    {
        key: 'csv',
        label: 'CSV',
        placeholder: csvPlaceholder,
        targets: [
            {key: 'json', label: 'JSON', convert: csvToJson, extension: 'json', mimeType: 'application/json', formattable: true},
            {key: 'xml', label: 'XML', convert: csvToXml, extension: 'xml', mimeType: 'application/xml', formattable: true},
            {key: 'yaml', label: 'YAML', convert: csvToYaml, extension: 'yaml', mimeType: 'application/x-yaml'},
            {key: 'html', label: 'HTML', convert: csvToHtml, extension: 'html', mimeType: 'text/html'},
            {key: 'markdown', label: 'Markdown', convert: csvToMarkdown, extension: 'md', mimeType: 'text/markdown'},
        ],
    },
    {
        key: 'yaml',
        label: 'YAML',
        placeholder: yamlPlaceholder,
        targets: [
            {key: 'json', label: 'JSON', convert: yamlToJson, extension: 'json', mimeType: 'application/json', formattable: true},
            {key: 'xml', label: 'XML', convert: yamlToXml, extension: 'xml', mimeType: 'application/xml', formattable: true},
            {key: 'csv', label: 'CSV', convert: yamlToCsv, extension: 'csv', mimeType: 'text/csv'},
        ],
    },
    {
        key: 'xml',
        label: 'XML',
        placeholder: xmlPlaceholder,
        targets: [
            {key: 'json', label: 'JSON', convert: xmlToJson, extension: 'json', mimeType: 'application/json', formattable: true},
            {key: 'yaml', label: 'YAML', convert: xmlToYaml, extension: 'yaml', mimeType: 'application/x-yaml'},
            {key: 'csv', label: 'CSV', convert: xmlToCsv, extension: 'csv', mimeType: 'text/csv'},
        ],
    },
]
